import cn from "classnames";
import { useEffect } from "react";
import { useLocation } from "react-router";

import { AppointmentConfirmation } from "../../components/desktop/screens/appointment-confirmation/appointment-confirmation";
import { AppointmentContent } from "../../components/desktop/screens/appointment-content/appointment-content";
import { AvailabilitySelector } from "../../components/desktop/screens/availability-selector/availability-selector";
import { useMultiStepForm } from "../../hooks/use-multi-step-form";
import { HeaderFooterLayout } from "../../layouts/desktop/header-footer-layout/header-footer-layout";
import { useGeneralStore } from "../../store/general/general-store";
import styles from "./desktop.module.scss";

export function Desktop() {
  const { pathname } = useLocation();
  const path = pathname.split("/")[1];
  const hideHeader = path === "embed";
  const { setOnNext, setOnPrev, setOnReset, setCurrentStep } = useGeneralStore();
  const { next, prev, reset, steps, currentStepIndex } = useMultiStepForm([
    <AvailabilitySelector key="availability-selector" />,
    <AppointmentContent key="appointment-content" />,
    <AppointmentConfirmation key="appointment-confirmation" />,
  ]);

  useEffect(() => {
    setOnNext(next);
    setOnPrev(prev);
    setOnReset(reset);
    setCurrentStep(currentStepIndex);
  }, [setOnNext, setOnPrev, setOnReset, setCurrentStep, currentStepIndex]);

  return (
    <HeaderFooterLayout hideHeader={hideHeader}>
      <main className={cn(styles.desktopWrapper, hideHeader && styles.hideHeaderStyles)}>{steps[currentStepIndex]}</main>
    </HeaderFooterLayout>
  );
}
